import { useMemo } from "react";
import { Tab } from "@headlessui/react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useModules } from "../../hooks";

const HeaderTabs = () => {
  const location = useLocation();

  const clientInfo = useSelector((state) => state.client.clientInfo);
  const user = useSelector((state) => state.user.user);

  const hasAccount = Boolean(clientInfo?.accounts_length > 0);
  const isNewCryptoUserEnabled = Boolean(clientInfo?.enable_new_crypto);

  const isCryptoEnabled = useModules("Crypto");
  const isCardEnabled = useModules("Card");
  const isBitpaceEnabled = useModules("Bitpace");
  const isFireblocksEnabled = useModules("Fireblocks");

  const availableTabs = useMemo(() => {
    if (!hasAccount || user?.is_basic_client) {
      return [{ label: "Accounts", path: "/" }];
    }

    return [
      { label: "Accounts", path: "/" },
      ...(isCardEnabled ? [{ label: "Cards", path: "/card" }] : []),
      ...(isCryptoEnabled
        ? [
            ...(isBitpaceEnabled ? [{ label: "Crypto", path: "/crypto" }] : []),
            ...(isBitpaceEnabled ? [{ label: "Advance Crypto", path: "/crypto-advance" }] : []),
            ...(!isBitpaceEnabled && isFireblocksEnabled
              ? [{ label: "Crypto", path: "/crypto" }]
              : []),
            ...((isBitpaceEnabled && isFireblocksEnabled) ||
            (isNewCryptoUserEnabled && !isFireblocksEnabled)
              ? [{ label: "New Crypto", path: "/v2/crypto" }]
              : []),
          ]
        : []),
    ];
    // eslint-disable-next-line
  }, [
    hasAccount,
    user?.is_basic_client,
    isCardEnabled,
    isCryptoEnabled,
    isBitpaceEnabled,
    isFireblocksEnabled,
    isNewCryptoUserEnabled,
  ]);

  return (
    <div className="md:block hidden">
      <Tab.Group>
        <Tab.List className="flex flex-wrap gap-2">
          {availableTabs.map((tab) => (
            <SingleTab
              key={tab.path}
              label={tab.label}
              to={tab.path}
              isSelected={
                tab.path === location.pathname ||
                (tab.path === "/crypto" &&
                  location.pathname === "/v2/crypto" &&
                  !isBitpaceEnabled &&
                  isFireblocksEnabled)
              }
            />
          ))}
        </Tab.List>
      </Tab.Group>
    </div>
  );
};

const SingleTab = ({ label, to, isSelected }) => (
  <Link to={to}>
    <Tab
      className={`header-tab-base ${
        isSelected ? "header-tab-selected" : "header-tab-unselected"
      }`}
    >
      {label}
    </Tab>
  </Link>
);

export default HeaderTabs;
